import { pathOr } from 'ramda'
import { IsDev } from '../../../helpers/build'

const offersMocked = IsDev ? (
  {
    TK: 'EARAD1',
    label: 'See aparthotels participants...',
    from: '2019-01-17',
    to: '2019-02-07',
    inputValue: 'Adagio Sao Paulo Itaim Bibi',
    hotelsInCity: '%n aparthotels',
    hotelsInCityMobile: '%n aparthotels',
    durationBanner: 'The dates you have selected are not compatible with the special offer %title so you will not be able to enjoy it.',
    list: [
      {
        city: 'Paris',
        icon: '/search/icons/EIFFEL_TOWER.svg',
        hotels: {
          493: {
            code: 2845,
            title: 'Adagio Sao Paulo Itaim Bibi',
          },
          495: {
            code: 2846,
            title: 'Adagio Sao Paulo Itaim Bibi',
          },
        },
      },
      {
        city: 'Aix-En-Provence',
        icon: '/search/icons/OFFER_CITY.svg',
        hotels: {
          493: {
            code: 2847,
            title: 'Aparthotel Adagio Aix-En-Provence Centre',
          },
        },
      },
      {
        city: 'Marseille',
        icon: '/search/icons/OFFER_CITY.svg',
        hotels: {
          493: {
            code: 2848,
            title: 'Aparthotel Adagio Marseille Vieux-Port',
          },
          495: {
            code: 2849,
            title: 'Aparthotel Adagio Marseille Saint-Charles',
          },
        },
      },
    ],
  }
) : {}

const offersMockedData = pathOr(offersMocked, ['drupalSettings', 'search', 'offer'], window)

export const hotelTitle = pathOr(null, ['drupalSettings', 'search', 'inputValue'], window)

export const pageTitle = IsDev ? 'Page title' : pathOr(null, ['drupalSettings', 'pageTitle'], window)
export const pageView = pathOr(null, ['drupalSettings', 'pageView'], window)

export const destinationsSearchPlaceholder = pathOr(null, ['drupalSettings', 'search', 'destinationsSearchPlaceholder'], window)


export const linkToFirstStep = pathOr(null, ['drupalSettings', 'widgets', 'filters', 'linkToFirstStep'], window)
export const linksToFirstStep = pathOr({
  '33c86e891ff341250ca72c16a087b268521c3db4d21447ce64e88dda912a979e': 'http://google.com',
}, ['drupalSettings', 'firstStepRedirectLinks'], window)

export const promoCodeRemoveUlr = pathOr(null, ['drupalSettings', 'search', 'api', 'promoCodeRemove'], window)

export default offersMockedData
